export { CustomerHotelFormComponent } from './hotel-form.component';
export { CustomerHotelImagesFormComponent } from './images/hotel-images-form.component';
export { CustomerHotelChainFormComponent } from './chain/hotel-chain-form.component';
